const styles = theme => ({
  root: {
    alignItems: 'center',
    backgroundColor: '#FFF',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    display: 'flex',
    height: 56,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 0.5,
    position: 'relative',
    zIndex: 10
  },
  searchWrapper: {
    alignItems: 'center',
    display: 'flex',
    flex: 1
  },
  searchRootIcon: {
    color: 'rgba(0, 0, 0, 0.54)'
  },
  searchRoot: {
    border: 0,
    fontSize: '16px',
    letterSpacing: '0.2px',
    lineHeight: '28px',
    fontWeight: 'normal',
    outline: 'none',
    '& fieldset': {
      border: '0 !important'
    }
  },
  iconButtonRoot: {
    position: 'relative'
  },
  menuItem: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    letterSpacing: '0.15px',
    lineHeight: '20px',
    backgroundColor: '#FFF !important',
    padding: '5.33px 36.4px 2.67px 16px',
    '&:hover': {
      backgroundColor: 'whitesmoke !important'
    }
  },
  organizationName: {
    paddingRight: theme.spacing.unit * 1.25,
    paddingLeft: theme.spacing.unit * 1.25
  },
  searchRow: {
    width: '100%',
    fontSize: '13px'
  }
});

export default styles;
